import { Amplify } from 'aws-amplify';

const amplifyConfig = {
  Auth: {
    Cognito: {
      // You'll need to replace these values with your actual Cognito configuration
      userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-2_GZ0aD3Fpq', // e.g., 'us-east-1_xxxxxxxxx'
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '1fa18i2gme996ftk9d2sfknp3f', // e.g., 'xxxxxxxxxxxxxxxxxxxxxxxxxx'
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: 'code', // 'code' | 'link'
      userAttributes: {
        email: {
          required: true,
        },
        name: {
          required: true
        }
      },
      allowGuestAccess: false,
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
};

Amplify.configure(amplifyConfig);

export default amplifyConfig;